import { useEffect, useState } from 'react'
import { useGeoLocationData, TRequestGetGeoLocation } from 'utility-tools/module/location'

const useAlertModalData = (requestGeoLocationNextApi: TRequestGetGeoLocation) => {
    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false)

    const { isCountryInRestrictedList } = useGeoLocationData(requestGeoLocationNextApi)

    useEffect(() => {
        setIsAlertModalOpen(isCountryInRestrictedList)
    }, [isCountryInRestrictedList]);

    const closeModal = () => {
        setIsAlertModalOpen(false)
    }

    return {
        isAlertModalOpen,
        closeModal
    }
}

export default useAlertModalData